import script from "./MensagemAlerta.vue?vue&type=script&setup=true&lang=js"
export * from "./MensagemAlerta.vue?vue&type=script&setup=true&lang=js"

import "./MensagemAlerta.vue?vue&type=style&index=0&id=74262db6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74262db6"]])

export default __exports__